<template>
  <a-tree-select
    v-model:value="staff"
    :treeDefaultExpandedKeys="treeDefaultExpandedKeys"
    :treeDefaultExpandAll="true"
    style="width: 100%; min-height: 32px; max-height: 200px"
    :tree-data="options"
    :filterTreeNode="searchStaff"
    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
    :tree-checkable="props.multiple"
    :multiple="props.multiple"
    :showSearch="true"
    @change="handleChooseStaffChange"
    @select="handleSelectStaff"
    :maxTagCount="10"
    allow-clear
    :replaceFields="{
      label: 'structureName',
      value: 'id',
      children: 'children',
    }"
    :show-checked-strategy="SHOW_PARENT"
    search-placeholder="请选择人员"
    placeholder="请选择人员"
    :disabled="props.disabled"
  >
  </a-tree-select>
</template>

<script>
import { defineComponent, ref, computed, watch, nextTick } from "vue";
import { getStructure } from "@/request/view/personal";
import { Toast } from "@/utils";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    echoStaff: String,
    echostaffUserName: String,
    echoStructtureName: String,
    multiple: Boolean,
    disabled: Boolean,
    appointDepartment: Array,
  },
  setup(props, context) {
    const store = useStore();

    const useAppointDepartment = () => {
      const appointList = [];
      const ite = (iteList) => {
        iteList.forEach((item) => {
          if (item.children && item.children.length > 0) ite(item.children);
          if (props.appointDepartment.find((v) => item.structureName === v)) {
            appointList.push(item);
          }
        });
      };

      ite(store.state.noticeStaffData);

      return appointList;
    };

    const useDeleteUserList = (list) => {
      const ite = (iteList) => {
        iteList.forEach((item) => {
          if (item.userList) delete item.userList;
          if (item.children && item.children.length > 0) ite(item.children);
        });
      };

      ite(list);

      return list;
    };

    const options = computed(() => {
      if (!props.appointDepartment)
        return useDeleteUserList(JSON.parse(JSON.stringify(store.state.noticeStaffData)));
      return useDeleteUserList(JSON.parse(JSON.stringify(useAppointDepartment())));
    });

    const staff = props.multiple ? ref([]) : ref(null);

    const staffName = [];

    const staffUserName = [];

    const structureName = [];
    // 将用户置入
    const setStructureBuyUser = (list) => {
      list.forEach((item) => {
        item.structureName = item.nickName;
        item.id = `P${item.id}`;
      });
      return list;
    };
    // 获取session中通知员工数据
    const getNoticeStaffBySession = () => {
      return new Promise((resolve, reject) => {
        const noticeStaffData = sessionStorage.getItem("noticeStaffData");
        resolve(noticeStaffData);
      });
    };
    // 获取服务器中的数据
    const getNoticeStaffByRequest = () => {
      return new Promise((resolve, reject) => {
        getStructure().then((res) => {
          if (res.code === 200) {
            const flatten = (list) => {
              list.forEach((item) => {
                if (item.userList && item.userList.length > 0) {
                  item.children.unshift(...setStructureBuyUser(item.userList));
                }
                if (item.children && item.children.length > 0) {
                  flatten(item.children);
                }
              });
            };
            flatten(res.data);
            resolve(res.data);
          }
        });
      });
    };
    //
    const setNoticeStaffData = (list) => {
      if (!list.length || list.length === 0) return;
      store.commit("SET_NOTICE_STAFF_DATA", list);
    };
    // 初始化数据
    const initOptionsData = async () => {
      const sessionStaffData = await getNoticeStaffBySession();

      if (sessionStaffData !== null) {
        setNoticeStaffData(JSON.parse(sessionStaffData));
        return;
      }

      const requestStaffData = await getNoticeStaffByRequest();
      setNoticeStaffData(requestStaffData);
      sessionStorage.setItem("noticeStaffData", JSON.stringify(requestStaffData));
    };

    const resetTreeSelect = () => {
      staff.value.length = 0;
    };

    initOptionsData();

    const searchStaff = (inputValue, treeNode) =>
      treeNode.props.structureName.indexOf(inputValue) !== -1;

    const handleSelectStaff = (value, node, extra) => {
      staffUserName.length = 0;
      structureName.length = 0;
      const idList = [];

      const selectStaff = props.multiple ? extra.checkedNodes : extra.selectedNodes;

      const fstaff = selectStaff.filter((item) => typeof item.key === "string");

      fstaff.forEach((item) => {
        staffUserName.push(item.props.nickName);
        const department = item.props.secondaryDepartment || item.props.firstLevelDepartment;
        structureName.push(department);
        idList.push(item.props.id.replace(/P/g, ""));
      });
      context.emit("getChooseStaff", {
        idList,
        staffName,
        staffUserName,
        structureName,
      });
    };

    const getChooseStaff = () => {
      const noticeStaffString = staff.value.toString().replace(/P/g, "");
      return { noticeStaffString, staffName, staffUserName, structureName };
    };

    const handleChooseStaffChange = (value, label, extra) => {
      staffName.length = 0;
      staffName.push(...label);

      if (staffName.length === 0) {
        context.emit("getChooseStaff", {
          staffUserName: staffName,
        });
      }
    };

    const clearSelect = () => {
      if (props.multiple) {
        staff.value.length = 0;
      } else {
        staff.value = null;
      }

      staffName.length = 0;
      staffUserName.length = 0;
    };

    const treeDefaultExpandedKeys = ref([1]);

    const setEcho = (val) => {
      if (props.multiple) {
        String(val)
          .split("#")
          .forEach((staffItem) => {
            const [id, nickName, structureName] = staffItem.split(",");
            staff.value.push(`P${id}`);
            staffUserName.push(...nickName);
          });
        return;
      }
      staff.value = `P${val}`;
      const nameList = String(props.echostaffUserName).split(",");
      staffUserName.push(...nameList);
    };

    watch(
      () => props.echoStaff,
      (val) => {
        if (!val) return;

        setEcho(val);
        // if (val && props.multiple) {
        //   const idList = String(val).split(",");
        //   idList.forEach((item) => {
        //     staff.value.push(`P${item}`);
        //   });
        //   console.log(staff.value, 'echo value');
        // } else if (val && !props.multiple) {
        //   staff.value = `P${val}`;
        // }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    // watch(
    //   () => props.echostaffUserName,
    //   (val) => {
    //     if (val) {
    //       const nameList = String(val).split(",");
    //       staffUserName.push(...nameList);
    //     }
    //   },
    //   {
    //     immediate: true,
    //     deep: true,
    //   }
    // );

    return {
      props,
      staff,
      options,
      treeDefaultExpandedKeys,
      getChooseStaff,
      handleSelectStaff,
      clearSelect,
      searchStaff,
      resetTreeSelect,
      handleChooseStaffChange,
    };
  },
});
</script>

<style lang="less" scoped></style>
